module.exports = __webpack_public_path__ + "img/organisation.3b84917e.svg";